
// class Report extends
import { Vue, Component } from 'vue-property-decorator';
import Report from '@/views/Report.vue';
import UrlMixin from '@/components/query/url-mixin';
import {mixins} from 'vue-class-component';

@Component
export default class ReportEventsMixin extends mixins(UrlMixin) {
  target: Report;


  registerEvents() {
    //for upper level
    if (!this.target.subReport) {
      this.bus.on('clear-report-selection', this.onBusClearSelection);
      this.bus.on('reload-report', this.onBusReloadReport);
      this.bus.on('refresh-report', this.onBusRefreshReport);
      this.bus.on('marks-added', this.onBusMarksAdded);
      this.bus.on('export-set-columns', this.onBusExportSetColumns);
      this.bus.on('apply-filters-orderBy', this.onBusApplyFiltersOrderBy);
      this.bus.on('freeze-table', this.onBusFreezeTable);
      this.bus.on('set-report-loading', this.onBusSetReportLoading);
    }
  }

  unregisterEvents() {
    this.bus.off('clear-report-selection', this.onBusClearSelection);
    this.bus.off('refresh-report', this.onBusRefreshReport);
    this.bus.off('reload-report', this.onBusReloadReport);
    this.bus.off('marks-added', this.onBusMarksAdded);
    this.bus.off('export-set-columns', this.onBusExportSetColumns);
    this.bus.off('apply-filters-orderBy', this.onBusApplyFiltersOrderBy);
    this.bus.off('freeze-table', this.onBusFreezeTable);
    this.bus.off('set-report-loading', this.onBusSetReportLoading);
  }

  onBusSetReportLoading(value: boolean) {
    this.target.loading = value;
  }

  onBusFreezeTable() {
    this.target.loading = true;
    
    this.$nextTick(() => {
      this.target.freezed = true;
    });
  }

  onBusApplyFiltersOrderBy(value: ColumnsSort) {
    //@ts-ignore
    this.sorting_filters.sortBy = value.orderBy;
    //@ts-ignore
    this.sorting_filters.descending = value.orderDir === 'desc';
  }

  onBusExportSetColumns(columns: string[]) {
    (this.target as any).exportColumns = columns;
  }

  onBusReloadReport() {
    this.target.loading = true;
    this.target.getReport();
  }

  onBusRefreshReport() {
    if (this.target.loading)
      return;

    //this.$store.commit('loading', true);

    this.target.refreshing = true;
    this.target.getReport();
  }

  updateRows(form, target) {
    if (!target) return
    target.rows
        .filter((row) => ((form as Bemob.CustomMark).customValues || (form as Bemob.CustomMarkBase).ids).includes(row.DT_RowId))
        .forEach((row) => row.DT_RowMark = form.mark);

    target.$children.forEach(child => {
      const tree = child.$refs['tree']?.[0]?.$refs['tree-child']
      tree && this.updateRows(form, tree)
    })
  }

  onBusMarksAdded(form: Bemob.CustomMark | Bemob.CustomMarkBase) {
    this.updateRows(form, this.target)

    this.onBusClearSelection();
  }

  onBusClearSelection() {
    this.$store.commit('tableSelectedItems', []);
    this.$store.commit('tableNextReportGroup', null);
  }
}
